import * as React from 'react';
import {
    Modal,
    Button,
    ButtonGroup,
    FormControl,
    FormGroup,
    ControlLabel,
    Checkbox,
    HelpBlock,
    Tab,
    Nav,
    NavItem,
    Table
} from 'react-bootstrap';
import { Translate } from '../../../../../shared/LanguageService';
import FormSelect from '../../../../../components/common/FormSelect';
import ConfirmationModal from '../../../../../components/common/ConfirmationModal';
import { ISelect, IOrderRow } from './entities';
import BasicOrderInfoApi from '../../basicorderinfo/BasicOrderInfoApi';

interface IOrderRowsFormProps {
    orderRows: IOrderRow[];
    products: any[];
    orderId: number;
    removeOrderRow: (id: number) => void;
    addOrderRow: (productId: number) => void;
    editOrderRow: (id: number) => void;
}

class OrderRowsForm extends React.Component<IOrderRowsFormProps, any> {
    constructor(props: IOrderRowsFormProps, context: any) {
        super(props, context);

        this.state = {
            isProductEdit: false,
            selectedProduct: '',
            showDeleteConfirmModalForOrderRowId: 0,
            includeFileRemovalWarning: false
        };

        this.addOrderRow = this.addOrderRow.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps: IOrderRowsFormProps) {
        if (nextProps.products && nextProps.products.length > 0) {
            this.setState({
                selectedProduct: nextProps.products[0].id.toString()
            });
        }
    }

    addOrderRow() {
        if (!this.props.products.some((x) => x.id.toString() === this.state.selectedProduct)) {
            return;
        }

        this.props.addOrderRow(this.state.selectedProduct);
    }

    showDeleteConfirmation(orderRowId: number) {
        BasicOrderInfoApi.getOrderRowDeleteStatus(this.props.orderId, orderRowId).then(
            (response) => {
                this.setState({
                    showDeleteConfirmModalForOrderRowId: orderRowId,
                    includeFileRemovalWarning: response.operationWillCauseFilesToBeRemoved
                });
            }
        );
    }

    closeDeleteConfirmation() {
        this.setState({
            showDeleteConfirmModalForOrderRowId: 0,
            includeFileRemovalWarning: false
        });
    }

    getDeleteText() {
        if (this.state.includeFileRemovalWarning) {
            return (
                <p>
                    <i className="material-icons">warning</i>{' '}
                    {Translate(
                        'view-order/basic-order-info/products/delete-confirmation-with-files'
                    )}
                </p>
            );
        }
        return (
            <p>
                <span>{Translate('view-order/basic-order-info/products/delete-confirmation')}</span>
            </p>
        );
    }

    render() {
        return (
            <FormGroup>
                <ControlLabel>{Translate('view-order/admin-planorder/order-rows')} </ControlLabel>
                <Table striped responsive className="no-bottom-margin">
                    <tbody>
                        {this.state.isProductEdit && (
                            <tr>
                                <td colSpan={2}>
                                    <FormGroup bsSize="sm">
                                        <FormSelect
                                            name="productId"
                                            value={this.state.selectedProduct}
                                            onChange={(e: any) =>
                                                this.setState({
                                                    selectedProduct: e.target.value
                                                })
                                            }
                                        >
                                            {this.props.products &&
                                                this.props.products.map((t: ISelect) => (
                                                    <option
                                                        key={'product_' + t.id}
                                                        value={t.id.toString()}
                                                    >
                                                        {t.name}
                                                    </option>
                                                ))}
                                        </FormSelect>
                                    </FormGroup>
                                </td>
                                <td>
                                    <Button
                                        bsSize="xs"
                                        bsStyle="success"
                                        className="pull-right"
                                        onClick={this.addOrderRow}
                                    >
                                        <i className="material-icons md-18">add</i>{' '}
                                        {Translate('view-order/admin-planorder/order-rows/add')}
                                    </Button>
                                </td>
                            </tr>
                        )}
                        {this.props.orderRows &&
                            this.props.orderRows.map((x, index) => (
                                <tr key={'orderrow' + index}>
                                    <td className="min-padding">{x.quantity}</td>
                                    <td className="min-padding">{x.name}</td>
                                    <td>
                                        {this.state.isProductEdit && (
                                            <ButtonGroup className="pull-right" bsSize="xs">
                                                <Button
                                                    disabled={!x.canChange}
                                                    onClick={() => this.props.editOrderRow(x.id)}
                                                    className="icon-only btn-inline"
                                                >
                                                    <i className="material-icons md-18">edit</i>
                                                </Button>
                                                <Button
                                                    disabled={!x.canRemove}
                                                    onClick={() =>
                                                        this.showDeleteConfirmation(x.id)
                                                    }
                                                    bsStyle="danger"
                                                    className="icon-only btn-inline"
                                                >
                                                    <i className="material-icons md-18">delete</i>
                                                </Button>
                                            </ButtonGroup>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        <tr>
                            <td colSpan={3}>
                                <Button
                                    bsStyle="info"
                                    bsSize="xs"
                                    className="pull-right"
                                    onClick={() =>
                                        this.setState({
                                            isProductEdit: !this.state.isProductEdit
                                        })
                                    }
                                >
                                    {!this.state.isProductEdit && (
                                        <i className="material-icons md-18">mode_edit</i>
                                    )}
                                    {this.state.isProductEdit && (
                                        <i className="material-icons md-18">done</i>
                                    )}
                                    {this.state.isProductEdit
                                        ? Translate(
                                              'view-order/admin-planorder/order-rows/edit/done'
                                          )
                                        : Translate('view-order/admin-planorder/order-rows/edit')}
                                </Button>
                            </td>
                        </tr>
                    </tbody>
                </Table>
                {this.state.showDeleteConfirmModalForOrderRowId > 0 && (
                    <ConfirmationModal
                        closeModal={() => this.closeDeleteConfirmation()}
                        title={Translate('delete/modal/title/delete')}
                        text={this.getDeleteText()}
                        doButtonLabel={Translate('delete/modal/footer/button-label/delete')}
                        cancelButtonLabel={Translate('delete/modal/footer/button-label/cancel')}
                        doButtonStyle="danger"
                        do={() =>
                            this.props.removeOrderRow(
                                this.state.showDeleteConfirmModalForOrderRowId
                            )
                        }
                        disableSubmit={true}
                        initialSubmitDisabling={false}
                    />
                )}
            </FormGroup>
        );
    }
}

export default OrderRowsForm;
